define('utils/messages',['jquery', 'utils/common'], function ($) {
	
	$('#notification-container').on('click', '.notification', function() {
		if (!$(this).data('fade')) {
			$.post($.url('/message/close', {'id': $(this).data('id')}), {});
		}
		$(this).fadeOut(750, function() {
			$(this).remove();
		});
	});
    $('.notification[data-fade^="true"]').delay(5000).fadeOut(750, function() {
		$(this).remove();
	});
	
});
